import { Check } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import { TERMS_URL, scrollToForm } from "../config";

const SUPPORT_ITEMS = [
  "Account setup guidance",
  "Equipment & technology",
  "Integrations",
  "Installation & configuration",
  "Testing",
  "Training & support",
  "Ongoing support",
];

export const SwitchingSupport = () => (
  <section id="switching-support" data-testid="switching-support" className="border-y border-white/10 bg-surface/40 py-24 sm:py-28">
    <div className="mx-auto max-w-7xl px-6">
      <SectionTag index="04" label="Switching Support" />
      <div className="mt-6 grid gap-12 lg:grid-cols-2">
        <Reveal>
          <h2 className="font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
            If You Switch, <span className="text-mint">You Won't Do It Alone.</span>
          </h2>
          <p className="mt-5 max-w-md leading-relaxed text-white/60">
            Changing processors can sound like a project. If your review shows switching makes
            sense, your CardConnect transition team will walk you through each step and explain
            what to expect before anything changes.
          </p>
          <p className="mt-6 rounded-2xl border border-amber-500/30 bg-amber-500/10 px-5 py-4 text-sm leading-relaxed text-amber-200/90" data-testid="switch-credit-note">
            Eligible businesses may qualify for up to $1,000 in switching credit.{" "}
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" data-testid="terms-link" className="font-bold text-amber-400 underline">
              Terms and conditions apply.
            </a>
          </p>
          <button
            data-testid="switching-cta"
            onClick={scrollToForm}
            className="mt-8 font-mono text-xs font-bold uppercase tracking-[0.25em] text-mint transition-transform duration-300 hover:translate-x-1"
          >
            Start with a free review →
          </button>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="grid content-start gap-3 sm:grid-cols-2">
            {SUPPORT_ITEMS.map((item) => (
              <div
                key={item}
                className="flex items-center gap-3 rounded-xl border border-ink/10 bg-void/60 px-4 py-3.5 text-sm text-white/80 transition-colors duration-300 hover:border-mint/40"
              >
                <Check size={16} className="shrink-0 text-mint" />
                {item}
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
